/**
 * 关联推荐
 */
import React, { FC, useEffect, useMemo, useState } from 'react'
import { productMobx } from '@mobx/mall'
import RecommentProductItem from '@pages/mall/mall/components/ProductItem/RecommentProductItem'
import { MallController } from '@ctrls/mallController'
import './index.scss'
import { observer } from 'mobx-react'

interface IProps {
  productNo: string;
}

const RecommendProduct: FC<IProps> = ({ productNo }) => {
  const [products, setProducts] = useState<any[]>([])
  const style = {
    width: 128,
    height: 190,
  }
  const getProduct = async () => {
    let prod = await MallController.getRecommendProduct(productNo)
    setProducts([...prod])
  }
  useEffect(() => {
    getProduct()
  }, [productNo])
  return (
    <>
      {
        products.length > 0 && (
          <div className='mall-recommend-product-container'>
            <div className='title-wrapper'>{i18n.t('mall.recommend')}</div>
            <div className='product-scroll-wrapper'>
              <div className='product-list-wrapper'>
                {
                  products.map((product) => {
                    return <RecommentProductItem key={product.no} style={style} product={product} />
                  })
                }
              </div>
            </div>
          </div>
        )
      }
    </>
  )
}

export default observer(RecommendProduct)
